export default "__VITE_ASSET__9157c94f__"